import { useState } from "react";

import { Button } from "common/components/ui/Button";
import {
  DialogBody,
  DialogClose,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  DrawerBody,
  DrawerClose,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import CsvOverview from "../CsvOverview";
import CsvUpload from "./CsvUpload";

import type { CsvState, ListLeadListSource } from "../../../types";

interface CustomListProps {
  createSource: (params: { settings: ListLeadListSource["settings"] }) => void;
  isCreatingSource: boolean;
  goBack: () => void;
}

export default function CustomList({
  createSource,
  isCreatingSource,
  goBack,
}: CustomListProps) {
  const isDesktop = useTwBreakpoint("lg");

  const [uploadState, setUploadState] = useState<
    ({ csvState: CsvState } & { sourceName: string }) | undefined
  >();
  const [mainIdentifier, setMainIdentifier] = useState(undefined);

  function onAdd() {
    createSource({
      settings: {
        type: "list",
        profiles: uploadState.csvState.parsed,
        url_column: mainIdentifier,
      },
    });
  }

  const Header = isDesktop ? DialogHeader : DrawerHeader;
  const Body = isDesktop ? DialogBody : DrawerBody;
  const Close = isDesktop ? DialogClose : DrawerClose;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;

  return (
    <>
      <Header
        title="Import custom list"
        onBack={uploadState ? () => setUploadState(undefined) : goBack}
      />
      <Body>
        {uploadState ? (
          <CsvOverview
            uploadState={uploadState}
            mainIdentifier={mainIdentifier}
            setMainIdentifier={setMainIdentifier}
          />
        ) : (
          <CsvUpload
            onSuccess={(csvState, fileName) => {
              setUploadState({ csvState, sourceName: fileName });
              if (csvState.url_columns.length) {
                setMainIdentifier(csvState.url_columns[0]);
              }
            }}
          />
        )}
      </Body>
      {uploadState && (
        <Footer className="justify-between">
          <Close asChild>
            <Button variant="secondary-black">Cancel</Button>
          </Close>
          <Button
            disabled={!uploadState || !mainIdentifier}
            isLoading={isCreatingSource}
            onClick={onAdd}
          >
            Add list
          </Button>
        </Footer>
      )}
    </>
  );
}
